module.exports = __webpack_public_path__ + "assets/img/media-music-layer-49-cdd5f3fa.png";